import {
  Badge,
  Box,
  HStack,
  Icon,
  Image,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import formatDate from "../../lib/formatDate";
import {
  BookOpenText,
  GlobeSimple,
  Student,
  UsersThree,
} from "@phosphor-icons/react";
import { iconSize } from "../../const/sizes";

type Props = {
  data: any;
};

export default function AdminCard({ data }: Props) {
  return (
    <VStack
      h={"240px"}
      align={"stretch"}
      gap={0}
      borderRadius={8}
      overflow={"hidden"}
      boxShadow={"0 0 10px 1px var(--divider2)"}
      // border={"1px solid var(--divider3)"}
    >
      <HStack
        flex={1}
        align={"stretch"}
        bg={data.id === 1 ? "#111" : "p.500"}
        h={"200px"}
        position={"relative"}
      >
        <Image
          src={
            data.image
              ? `${process.env.REACT_APP_MEDIA_BASE_URL}${data.image}`
              : "/images/defaultProfile.svg"
          }
          objectFit={"cover"}
          w={"140px"}
          borderRadius={0}
        />

        <VStack
          align={"stretch"}
          p={5}
          gap={0}
          flex={1}
          color={data.id === 1 ? "yellow.500" : "white"}
          justify={"space-between"}
          zIndex={2}
        >
          <VStack align={"flex-start"} gap={1}>
            <Tooltip label={data.name}>
              <Text
                noOfLines={1}
                lineHeight={1.2}
                fontSize={20}
                fontWeight={600}
              >
                {data.name}
              </Text>
            </Tooltip>
            <Text noOfLines={1} fontSize={12}>
              {data.username}
            </Text>
            <Text noOfLines={1} opacity={0.5} fontSize={12}>
              {data?.email || "-"}
            </Text>
            <Text noOfLines={1} opacity={0.5} fontSize={12}>
              {data?.phone || "-"}
            </Text>
          </VStack>

          <Box>
            <Text opacity={0.5} fontSize={12}>
              Dibuat
            </Text>

            <HStack w={"100%"}>
              <Text>
                {data.id === 1
                  ? "-"
                  : formatDate(data.created_at, {
                      day: "numeric",
                      month: "numeric",
                      year: "numeric",
                    })}
              </Text>

              <Badge
                w={"fit-content"}
                ml={"auto"}
                zIndex={2}
                bg={data.status ? "var(--greena)" : "var(--reda)"}
                color={data.status ? "green.300" : "red.300"}
              >
                {data.status ? "Aktif" : "Tidak Aktif"}
              </Badge>
            </HStack>
          </Box>
        </VStack>

        <Image
          src={"/images/logoTransparent.png"}
          h={"120px"}
          objectFit={"contain"}
          position={"absolute"}
          right={0}
          top={0}
          opacity={0.1}
          zIndex={1}
        />
      </HStack>

      <HStack
        color={data.id === 1 ? "yellow.500" : "p.500"}
        bg={"white"}
        justify={"space-between"}
        py={2}
        px={5}
        flexShrink={0}
        h={"40px"}
      >
        <Text fontWeight={700}>{data.id.toString().padStart(3, "0")}</Text>

        <HStack>
          {data.roles.adminAccount && (
            <Tooltip label={"Admin Account"}>
              <Icon as={UsersThree} fontSize={iconSize} weight="fill" />
            </Tooltip>
          )}
          {data.roles.adminCmsLandingpage && (
            <Tooltip label={"Admin CMS Landing Page"}>
              <Icon as={GlobeSimple} fontSize={iconSize} weight="fill" />
            </Tooltip>
          )}
          {data.roles.adminBlog && (
            <Tooltip label={"Admin Blog"}>
              <Icon as={BookOpenText} fontSize={iconSize} weight="fill" />
            </Tooltip>
          )}
          {data.roles.adminCourse && (
            <Tooltip label={"Admin Course"}>
              <Icon as={Student} fontSize={iconSize} weight="fill" />
            </Tooltip>
          )}
        </HStack>
      </HStack>
    </VStack>
  );
}
